import React from "react";
import { QRCodeSVG } from "qrcode.react";

export const COMPANY_NAME = "GLOMETS INC";

// One 4x6 inch finished-goods sticker. Designed for Rollo thermal printer.
// Dimensions are inches so the @page rule in StickerPrintArea drives layout.
export default function StickerLabel({ box }) {
  if (!box) return null;
  const fmtWt = (n) => `${(Number(n) || 0).toFixed(2)} lb`;
  const fmtDate = (d) => {
    if (!d) return "";
    const dt = new Date(d);
    if (isNaN(dt.getTime())) return String(d).split("T")[0];
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    const day = String(dt.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  };

  return (
    <div
      className="sticker-label"
      style={{
        width: "4in",
        height: "6in",
        boxSizing: "border-box",
        padding: "0.18in",
        fontFamily: "Arial, sans-serif",
        color: "#000",
        display: "flex",
        flexDirection: "column",
        pageBreakAfter: "always",
        breakAfter: "page",
      }}
    >
      {/* Company header */}
      <div style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: "0.08in" }}>
        <div style={{ fontSize: "22pt", fontWeight: 700, letterSpacing: "1px" }}>{COMPANY_NAME}</div>
        <div style={{ fontSize: "10pt", marginTop: "0.02in" }}>FINISHED GOODS</div>
      </div>

      {/* Product */}
      <div style={{ marginTop: "0.15in", fontSize: "11pt" }}>
        <div style={{ color: "#444", fontSize: "9pt" }}>PRODUCT</div>
        <div style={{ fontSize: "16pt", fontWeight: 700, lineHeight: 1.1 }}>
          {box.Item_Description || "-"}
        </div>
      </div>

      {/* Pack type + Date */}
      <div style={{ marginTop: "0.12in", display: "flex", justifyContent: "space-between", fontSize: "11pt" }}>
        <div>
          <div style={{ color: "#444", fontSize: "9pt" }}>PACK TYPE</div>
          <div style={{ fontWeight: 600 }}>{box.PackType || "Boxes"}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ color: "#444", fontSize: "9pt" }}>DATE</div>
          <div style={{ fontWeight: 600 }}>{fmtDate(box.PackedAt)}</div>
        </div>
      </div>

      {/* Weights */}
      <div
        style={{
          marginTop: "0.15in",
          border: "1.5px solid #000",
          borderRadius: "4px",
          padding: "0.1in 0.15in",
          fontSize: "13pt",
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.05in" }}>
          <span>GROSS</span><span style={{ fontWeight: 700 }}>{fmtWt(box.GrossWt)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "0.05in" }}>
          <span>TARE</span><span style={{ fontWeight: 700 }}>{fmtWt(box.TareWt)}</span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderTop: "1px dashed #000",
            paddingTop: "0.05in",
            fontSize: "16pt",
          }}
        >
          <span>NET</span><span style={{ fontWeight: 800 }}>{fmtWt(box.NetWt)}</span>
        </div>
      </div>

      {/* Spacer */}
      <div style={{ flex: 1 }} />

      {/* QR + code */}
      <div style={{ display: "flex", alignItems: "center", gap: "0.12in", justifyContent: "center" }}>
        <QRCodeSVG value={box.StickerCode || ""} size={110} level="M" includeMargin={false} />
        <div>
          <div style={{ color: "#444", fontSize: "9pt" }}>STICKER</div>
          <div style={{ fontSize: "18pt", fontWeight: 800, letterSpacing: "1px" }}>
            {box.StickerCode || "-"}
          </div>
        </div>
      </div>
    </div>
  );
}
